import React, { useState } from 'react'
import { Search, Filter, Plus, Tiret } from 'lucide-react'
import './SearchFilters.scss'

const SearchFilters = ({
  searchValue,
  onSearchChange,
  filters = [],
  extraFilters = null,
  extraFiltersDisable = null,
}) => {
  const [showExtraFilters, setShowExtraFilters] = useState(false)
  return (
    <div className='search-filters'>
      <div className='form-group'>
        <div className='search-row'>
          <div className='form-field relative flex-1'>
            <Search size={20} className='field-icon' />
            <input
              type='text'
              placeholder='Rechercher...'
              value={searchValue}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>

          {filters.map((filter, index) => (
            <div
              key={index}
              className='form-field relative'
              style={{ position: 'relative' }}
            >
              <Filter size={20} className='field-icon' />
              <select
                style={{ paddingLeft: '40px', cursor: 'pointer' }}
                value={filter.value}
                onChange={(e) => filter.onChange(e.target.value)}
              >
                {filter.options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {filter.value !== 'all' && (
                <p className='filter-actif-repert'></p>
              )}
            </div>
          ))}
        </div>

        {extraFilters && (
          <>
            <p className='showExtraFilters'>
              <span
                onClick={() => {
                  setShowExtraFilters(!showExtraFilters)
                }}
              >
                {showExtraFilters ? (
                  '-  '
                ) : (
                  <Plus size={15} className='btn-icon' />
                )}
                {showExtraFilters
                  ? 'Afficher moins'
                  : 'Afficher plus de filtre'}
              </span>
            </p>

            <div className='showExtraFiltersMobile'>
              {showExtraFilters && extraFilters && extraFilters}
            </div>
            <div className='showExtraFiltersDesktop'>
              {extraFilters && extraFilters}
            </div>
          </>
        )}

        {filters.map(
          (filter, index) =>
            (filter.value !== 'all' || extraFiltersDisable) && (
              <p className='feedback-filtre-actif'>
                Vous avez un ou plusieurs filtres activés
              </p>
            ),
        )}
      </div>
    </div>
  )
}

export default SearchFilters
